import React, { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import ScaledSlide from "./ScaledSlide";

// Saisie en cours : les touches restent au texte.
const typing = (target) => target?.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(target?.tagName);

const NEXT_KEYS = ["ArrowRight", "ArrowDown", "PageDown"];
const PREVIOUS_KEYS = ["ArrowLeft", "ArrowUp", "PageUp"];

// La slide ouverte sur tout l'écran : flèches pour passer d'une slide à l'autre, Échap pour revenir.
const SlideViewer = ({ slides, slideId, pages, onSelect, onClose, children }) => {
  const index = slides.findIndex((item) => item.id === slideId);
  const previous = slides[index - 1];
  const next = slides[index + 1];

  useEffect(() => {
    const onKey = (event) => {
      if (typing(event.target)) return;
      if (event.key === "Escape") onClose();
      else if (NEXT_KEYS.includes(event.key) && next) onSelect(next.id);
      else if (PREVIOUS_KEYS.includes(event.key) && previous) onSelect(previous.id);
      else return;
      event.preventDefault();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [next, previous, onSelect, onClose]);

  useEffect(() => {
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = overflow; };
  }, []);

  const button = "rounded-full p-2 text-slate-200 hover:bg-white/10 disabled:opacity-30";
  return (
    <div role="dialog" aria-modal="true" aria-label="Slide en grand" className="fixed inset-0 z-[60] flex flex-col bg-slate-900">
      <div className="flex shrink-0 items-center justify-between gap-3 px-4 py-2 text-sm text-slate-300">
        <span>Slide {pages[slideId] ?? "masquée"} · {index + 1} sur {slides.length}</span>
        <div className="flex items-center gap-1">
          <button type="button" className={button} disabled={!previous} onClick={() => onSelect(previous.id)}
            title="Slide précédente (←)" aria-label="Slide précédente"><ChevronLeft className="h-5 w-5" /></button>
          <button type="button" className={button} disabled={!next} onClick={() => onSelect(next.id)}
            title="Slide suivante (→)" aria-label="Slide suivante"><ChevronRight className="h-5 w-5" /></button>
          <button type="button" className={button} onClick={onClose} title="Revenir à l'édition (Échap)" aria-label="Fermer">
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
      <div className="min-h-0 flex-1 px-4 pb-4">
        <ScaledSlide fit center className="rounded-md bg-white shadow-2xl">{children}</ScaledSlide>
      </div>
    </div>
  );
};

export default SlideViewer;
